import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import SakuraBackground from './components/SakuraBackground';
import MusicPlayer from './components/MusicPlayer';
import MainPage from './pages/MainPage';
import BlessingPage from './pages/BlessingPage';
import MemoriesPage from './pages/MemoriesPage';
import LoveListPage from './pages/LoveListPage';
import AlbumPage from './pages/AlbumPage';
import LoveTreePage from './pages/LoveTreePage';
import AboutPage from './pages/AboutPage';
import './App.css';

function App() {
  return (
    <Router basename="/love">
      <div className="App">
        <SakuraBackground />
        <MusicPlayer />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/blessing" element={<BlessingPage />} />
            <Route path="/memories" element={<MemoriesPage />} />
            <Route path="/love-list" element={<LoveListPage />} />
            <Route path="/album" element={<AlbumPage />} />
            <Route path="/love-tree" element={<LoveTreePage />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;


